<template>
  <el-card
    shadow="never"
    :body-style="{ padding: '15px' }"
    style="border: none"
    class="newshipv2tag"
  >
    <div slot="header" class="clearfix">
      <span style="font-size: 16px">标记</span>

      <el-button
        style="float: right; padding: 3px 0; margin-left: 10px"
        type="text"
        :disabled="!selections.length"
        class="danger-button"
        @click="tagrowRemove(selections)"
      >
        移除标记 {{ selections.length ? `(${selections.length})` : '' }}
      </el-button>

      <el-button
        style="float: right; padding: 3px 0"
        type="text"
        :disabled="!taglist.length"
        :loading="loading"
        @click="downloadtags"
      >
        下载标记项
      </el-button>
    </div>
    <el-table
      v-loading="loading"
      :data="taglist"
      max-height="500px"
      size="mini"
      @selection-change="handleselectchange"
    >
      <el-table-column type="selection" width="55" />
      <el-table-column prop="mmsi" label="MMSI" width="120">
        <div slot-scope="scope">
          <div>{{ scope.row.mmsi }}</div>
          <div
            v-if="scope.row.mmsi2"
            class="basicship-info"
            title="基础船舶对应mmsi"
          >
            {{ scope.row.mmsi2 }}
          </div>
        </div>
      </el-table-column>

      <el-table-column prop="nameEn" label="船名" width="160">
        <div slot-scope="scope">
          <div>{{ scope.row.nameEn }}</div>
          <div
            v-if="scope.row.nameEn2"
            class="basicship-info"
            title="基础船舶对应船名"
          >
            {{ scope.row.nameEn2 }}
          </div>
        </div>
      </el-table-column>
      <el-table-column prop="imo" label="IMO" width="120">
        <div slot-scope="scope">
          <div>{{ scope.row.imo }}</div>
          <div
            v-if="scope.row.imo2"
            class="basicship-info"
            title="基础船舶对应imo"
          >
            {{ scope.row.imo2 }}
          </div>
        </div>
      </el-table-column>
      <el-table-column prop="callSign" label="呼号" width="150" />

      <el-table-column prop="flagName" label="船旗" width="150" />

      <el-table-column
        prop="shipType"
        label="船舶类型"
        width="150"
        show-overflow-tooltip
      />

      <el-table-column prop="lastUpdateTime" label="最后更新时间" width="150">
        <div slot-scope="scope">
          {{ scope.row.lastUpdateTime | dateformat }}
        </div>
      </el-table-column>

      <el-table-column prop="updateTime" label="更新时间" width="150" />

      <el-table-column
        prop="updateCount"
        label="更新次数"
        align="right"
        width="100"
      >
        <div slot-scope="scope" class="newshipv2-num">
          {{ scope.row.updateCount }}
        </div>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="60" align="center">
        <div slot-scope="scope" style="text-align: center; width: 100%">
          <el-button
            type="text"
            size="mini"
            class="danger-button"
            @click="tagrowRemove([scope.row])"
          >
            移除
          </el-button>
        </div>
      </el-table-column>
    </el-table>
  </el-card>
</template>

<script>
import dayjs from 'dayjs'
export default {
  filters: {
    dateformat(value) {
      return value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : ''
    },
  },

  props: {
    taglist: {
      type: Array,
      defulat: () => [],
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      selections: [],
    }
  },

  methods: {
    tagrowRemove(rows) {
      rows = rows || []
      rows.forEach(it => this.$emit('removeTag', it))
    },

    downloadtags() {
      if (this.taglist.length) {
        this.$emit('downloadtags')
      }
    },

    handleselectchange(selections) {
      this.selections = selections
    },
  },
}
</script>

<style lang="scss" scoped>
.newshipv2tag {
  .clearfix:before,
  .clearfix:after {
    display: table;
    content: '';
  }

  .clearfix:after {
    clear: both;
  }

  .newshipv2-num {
    font-weight: bold;
    text-align: right;
    width: 80%;
  }

  .basicship-info {
    color: rgb(206, 206, 206);
  }

  .danger-button {
    &:not(.is-disabled) {
      color: #f56c6c;
    }
  }
}
</style>
